import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/iconfont/iconfont.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import api from './api'

// 引入全局样式
import '@/assets/css/global.css'

const app = createApp(App)
// 全局挂载 API
app.config.globalProperties.$api = api
app.use(router)
app.mount('#app')
